import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoundedButton from '@components/RoundedButton';

import { DASHBOARD } from '@constants/routes';

import { useSession } from '@hooks/useSession';

const messages = defineMessages({
  title: {
    id: 'missingConsentModalContent.title',
    defaultMessage: 'Consent is missing for this patient’s profile.',
  },
  description: {
    id: 'missingConsentModalContent.description',
    defaultMessage:
      'The patient or their account’s primary user must provide their consent to use and receive VITALL services.',
  },
  buttonText: {
    id: 'missingConsentModalContent.button',
    defaultMessage: 'Back to Your Profile',
  },
});

interface MissingConsentModalContentProps {
  onClose: () => void;
}

export default function MissingConsentModalContent({
  onClose: handleClose,
}: MissingConsentModalContentProps) {
  const { formatMessage } = useIntl();
  const { resetActiveProfile } = useSession();

  return (
    <>
      <DialogTitle>{formatMessage(messages.title)}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {formatMessage(messages.description)}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <RoundedButton
          autoSize
          height="32px"
          onClick={() => {
            resetActiveProfile();
            navigate(DASHBOARD);
            handleClose();
          }}
        >
          {formatMessage(messages.buttonText)}
        </RoundedButton>
      </DialogActions>
    </>
  );
}
